import { action, observable } from "mobx";
import { Logger } from "bernie-logger";
import { SerializedData, Store } from "bernie-core";
import { FlexTemplateNode } from "flex-template-renderer-react";
import { Composition, Template } from "src/typings/flexFramework/FlexDefinitions";
import { moduleDefinitionToFlexTemplateNode, flexComponentToFlexTemplateNode } from "src/stores/FlexTemplateStore";

export class FlexTemplateStore extends Store {
  @observable
  public flexTemplate: FlexTemplateNode[];

  /* istanbul ignore next */
  public constructor(state: SerializedData = {}, logger: Logger) {
    super(state, logger);
  }

  /* istanbul ignore next */
  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setup(structureInput: Template | Composition) {
    const isComposition = (structure: Template | Composition): structure is Composition => {
      return !!(structure as Composition).page;
    };

    this.flexTemplate = this.flexTemplate ?? [];

    if (isComposition(structureInput)) {
      structureInput.page.regionList.forEach((flexComponent) => {
        this.flexTemplate.push(flexComponentToFlexTemplateNode(flexComponent));
      });
    } else {
      structureInput.regions.forEach((moduleDefinition) => {
        this.flexTemplate.push(moduleDefinitionToFlexTemplateNode(moduleDefinition));
      });
    }
  }
}
